import { render, staticRenderFns } from "./matter-details.vue?vue&type=template&id=4f367309&scoped=true&"
import script from "./matter-details.vue?vue&type=script&lang=ts&"
export * from "./matter-details.vue?vue&type=script&lang=ts&"
import style0 from "./matter-details.vue?vue&type=style&index=0&id=4f367309&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f367309",
  null
  
)

export default component.exports